<template>
  <el-container id="glDevSonLd">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background:#FFFFFF;padding:15px">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <span style="margin-left:0;color: #ffffff; font-size: 13px">
            <el-select v-model="edi_jh" ref='select' @change="init_getDev()"
                       clearable filterable placeholder="全部设备"
                       style="width:10vw;">
              <el-option
                  v-for="item in li_jh"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="edi_state" ref='select' @change="init_getDev()"
                       clearable filterable placeholder="全部状态"
                       style="width:10vw;">
              <el-option
                  v-for="item in li_state"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </span>
          <el-button @click="addScene" size="small" type="primary" icon="el-icon-plus"
                     style="margin-left:auto;margin-right:15px">
            新增设备
          </el-button>
        </div>
        <div :class=grid_box :style="divStyle">
          <div :class=grid_item v-for="d in tabData">
            <el-main :class=man_li style="padding-right:10px">
              <div style="margin-top:1px;-moz-user-select: none;
                     height:30px; user-select: none;font-size:inherit;">
                <p style="float:left; margin-left: 10px;">{{ d.devName }}</p>
                <p style="float:right; margin-right: 10px;">{{ d.statusName }}</p>
              </div>
              <div style="height:80px"> <!--display:flex; align-items:center;justify-content:center;-->
                <p style="text-align:center;font-size:20px;margin-top:55px">{{ d.fire }}</p>
              </div>
              <div
                  style="display:flex;height:60px;width:100%;line-height:0.3;align-items:center;justify-content:center;">
                <p style="text-align:center;font-size:20px;margin-top:55px">{{ d.fire }}</p>
                <el-button v-if="d.isVirtual" @click="change_dvc(d)" type="text" size="small" icon="el-icon-edit"
                           style="color:#72767b;font-size:20px;"/>
                <el-button @click="del_Scene(d)" type="text" size="small" icon="el-icon-delete"
                           style="color:#72767b;font-size:20px;margin-left:25px"/>
              </div>
            </el-main>
          </div>
        </div>
        <el-pagination
            style="float:right; margin-right:0.5vw;margin-top:5px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange1"
            :current-page="page"
            :page-sizes="[10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog
        title="删除提示"
        :visible.sync="daidelDev"
        width="30%">
      <span>确定删除该设备吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daidelDev = false">取 消</el-button>
        <el-button type="primary" @click=delDev()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name:"glDevSonLd",
  data() {
    return {
      h_text:"设备列表",
      li_h_text:[
        {"text":"设备管理","colour":"#B7B7B7","pages":""}
      ],
      divStyle:{
        marginLeft:'15px',
        maxHeight:window.innerHeight - 170
      },
      tabData:[],
      is_one:true,
      page:1,
      total:0,
      pageSize:10,
      websocket:null,
      reconnectInterval:5000, // 5秒尝试重连一次
      heartbeatMsg:'ping',
      heartbeatInterval:60000, // 60秒发送一次心跳
      li_ctl:[],
      li_data:[],
      edi_jh:"",
      li_jh:[
        {
          value:true,
          label:'聚合设备'
        }
      ],
      edi_state:"",
      li_state:[
        {
          value:1,
          label:'离线'
        },
        {
          value:2,
          label:'在线'
        },
        {
          value:3,
          label:'故障'
        },
        {
          value:4,
          label:'其他'
        }
      ],
      grid_box:"grid_box",
      grid_item:"grid_item",
      man_li:"man_li",
      dailogShow:false,
      bj_daiLog:"data-dialog",
      bj_tab:"#FFFFFF",
      bj_dev_txt:"#000000",
      bj_tab_color:"#000000",
      bj_txt_line6:"#000000",
      dailog_qxbg:"#283A4D",
      dailog_qdbg:"#283A4D",
      dailog_qxbg_color:"#FFFFFF",
      dailog_qdbg_color:"#FFFFFF",
      pid:"pir_us_wsr2_wifi",
      virtualType:3,
      daidelDev:false
    };
  },
  methods:{ /*方法存放*/
    addScene() {
      this.$router.push({
        path:'/home/glDevListSon',
        query:{key:'addDev'}
      }); /*路由跳转*/
    },
    change_dvc(row) {
      console.log(row);
      console.log(row.li_son_dev);
      this.$router.push({
        path:'/home/glDevSonSon',
        query:{key:'upDev',dev_type:this.virtualType,did:row.did,pid:row.pid,li_son_dev:row.li_son_dev}
      }); /*路由跳转*/
    },
    del_Scene(row) {
      console.log(row);
      this.did = row.did;
      this.pid = row.pid;
      this.daidelDev = true;
    },
    delDev() {
      const params = {
        'did':this.did,
        'pid':this.pid,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delDevice,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("删除成功");
        this.daidelDev = false;
        this.getDev();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("删除失败");
        }
      });
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getDev();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.getDev();
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m + s;
    },
    init_View() {
      let l = [];
      if (this.is_one) {
        this.state_all = 0;
      }
      this.state_zx = 0;
      this.state_lx = 0;
      this.state_err = 0;
      let data = this.li_dev;
      let li_d = [];
      let j = 1;
      for (let i = 0; i < data.length; i++) {
        if (!data[i]["isShow"]) {
          continue;
        }
        // if (this.edi_jh && data[i].isVirtual !== this.edi_jh) {
        //   continue
        // }
        let d = {
          item:j,
          did:data[i]['did'],
          pid:data[i]['pid'],
          authName:data[i]['sysIotPid']['name'],
          devName:data[i]['name'],
          devMac:data[i]['did'],
          times:this.timestampToTime(data[i]['hearBeatTime'] * 1000),
          statusId:data[i]['statusId'],
          isVirtual:data[i]['isVirtual'],
          roomId:data[i]['roomId'],
          fire:data[i][''],
          li_son_dev:[]
        };
        if (data[i]['roomId']) {
          d['floorId'] = data[i]['room']['floorId'];
          if (data[i]['room']['floor']) {
            d['buildId'] = data[i]['room']['floor']['buildingId'];
            d['devArea'] = data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            if (data[i]['room']['floor']['building']) {
              d['devArea'] = data[i]['room']['floor']['building']['name'] + "-" + data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            }
          }
        } else if (data[i]['floorId']) {
          d['floorId'] = data[i]['floorId'];
          if (data[i]['floor']) {
            d['buildId'] = data[i]['floor']['buildingId'];
            d['devArea'] = data[i]['floor']['name'];
            if (data[i]['floor']['building']) {
              d['devArea'] = data[i]['floor']['building']['name'] + "-" + data[i]['floor']['name'];
            }
          }
        }
        for (let k = 0; k < data[i]['vGroupDevice'].length; k++) {
          d.li_son_dev.push(data[i]['vGroupDevice'][k]["did"]);
        }
        if (this.is_one) {
          this.state_all += 1;
        }
        if (d["statusId"] === 0) { /* 为0时直接离线 */
          d["statusId"] = 1;
          d["statusName"] = "离线";
          this.state_lx += 1;
        } else {
          if (d["statusId"] === 1) {
            this.state_lx += 1;
            d["statusName"] = "离线";
          } else if (d["statusId"] === 2) {
            this.state_zx += 1;
            d["statusName"] = "在线";
          }
          if (d["statusId"] === 3) {
            this.state_err += 1;
            d["statusName"] = "故障";
          }
          // const state = this.li_state.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
          //   return fruit['value'] === d.statusId;
          // })
          // if (state !== undefined) {
          //   d["statusName"] = state["label"];
          //   if (state["label"] === "在线") {
          //     this.state_zx += 1
          //   } else if (state["label"] === "离线") {
          //     this.state_lx += 1
          //   }
          //   if (state["label"] === "故障") {
          //     this.state_err += 1
          //   }
          // }
        }
        const authItems = l.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
          return fruit['value'] === d['pid'];
        });
        if (authItems === undefined) {
          l.push({
            value:d['pid'],
            label:d['authName']
          });
        }
        li_d.push(d);
        j += 1;
      }
      console.log(this.state_zx,this.state_lx,this.state_err);
      // this.total = li_d.length  /*当前页面总设备数量*/
      // this.tabData = li_d.slice((this.page - 1) * this.pageSize, this.page * this.pageSize)
      this.tabData = li_d;
      this.li_pid = l;
      this.is_one = false;
      if (this.websocket === null) {
        this.connect();
      } else {
        this.heartbeatMsg = {
          "type":"getDevState",
          "devices":[], // { "did": "ec0bf1069464","pid": "ble_light_rgbcw"}
          "projectId":localStorage.getItem("projectId")
        };
        for (let i = 0; i < this.li_dev.length; i++) {
          this.heartbeatMsg["devices"].push({"did":this.li_dev[i]["did"],"pid":this.li_dev[i]["pid"]});
        }
        if (this.websocket.readyState === WebSocket.OPEN) {
          console.log("socket发送数据",this.heartbeatMsg);
          this.websocket.send(JSON.stringify(this.heartbeatMsg));
        }
      }
    },
    getPidArg(pid) {
      const params = {
        'pid':pid
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getPidArg,params,headers).then(res => {
        console.log("pid参数",res.data.data);
        let data = res.data.data["iotPidProfile"]["properities"];
        let l = [];
        for (let i = 0; i < data.length; i++) {
          let d = {
            "name":data[i]['name'],
            "desc":data[i]['desc'],
            "type":data[i]["define"]['type'],
            "mode":data[i]['mode'],
            "value":""
          };
          l.push(d);
        }
        this.li_ctl = l;
        console.log("data",data);
        this.getDev();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备类型失败");
        }
      });
    },
    init_getDev() {
      this.page = 1;
      this.getDev();
    },
    getDev() {
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        "virtualType":this.virtualType, // 1 - 人体存在传感器类，2 - 温湿度传感器类 3 - 空气质量传感器类
        'projectId':localStorage.getItem("projectId")
      };
      if (this.edi_jh) {
        params["isVirtual"] = this.edi_jh;
      }
      if (this.edi_state) {
        params["statusId"] = this.edi_state;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getVGroupDeviceList,params,headers).then(res => {
        this.total = res.data.data["total"];
        this.li_dev = res.data.data["list"];
        console.log("所有雷达设备",this.li_dev);
        this.init_View();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    xhTime() { /*循环定时*/
      clearInterval(this.timer_sjtime); /*清除定时器*/
      this.timer_sjtime = setInterval(() => {   //设置延迟执行
        for (let i = 0; i < this.li_dev.length; i++) {
          const now = new Date();
          if (now.getTime() - this.li_dev[i]['time'] * 1000 <= 10 * 60 * 1000) {
            this.li_dev[i]["statusId"] = 2;
            this.li_dev[i]["statusName"] = "在线";
          } else {
            this.li_dev[i]["statusId"] = 1;
            this.li_dev[i]["statusName"] = "离线";
          }
        }
      },60000 * 10);
    },
    connect() {
      this.websocket = new WebSocket(this.$urls.websocketUrl + '/websocket/wsGetDevState',[localStorage.getItem("token")]);
      // this.websocket = new WebSocket('wss://localhost:12000/websocket/wsGetDevState', [localStorage.getItem("token")]);
      this.websocket.onopen = () => {
        console.log('连接成功');
        this.heartbeatMsg = {
          "type":"getDevState",
          "devices":[
            // { "did": "ec0bf1069464","pid": "ble_light_rgbcw"}
          ],
          "projectId":localStorage.getItem("projectId")
        };
        for (let i = 0; i < this.li_dev.length; i++) {
          this.heartbeatMsg["devices"].push({"did":this.li_dev[i]["did"],"pid":this.li_dev[i]["pid"]});
        }
        if (this.websocket.readyState === WebSocket.OPEN) {
          console.log("socket发送数据",this.heartbeatMsg);
          this.websocket.send(JSON.stringify(this.heartbeatMsg));
        }
      };
      this.websocket.onmessage = (event) => { /*打开后才接收数据*/
        if (this.websocket.readyState === WebSocket.OPEN) {
          let data = JSON.parse(event.data);
          this.handleReceivedData(data);
        }
      };
      this.timer_socket = setInterval(() => { /*心跳包*/
        if (this.websocket !== null && this.websocket.readyState === WebSocket.OPEN) {
          let heartbeatMsg1 = {
            "type":"heartbeat",
            "devices":[],
            "projectId":localStorage.getItem("projectId")
          };
          this.websocket.send(JSON.stringify(heartbeatMsg1));
        }
      },this.heartbeatInterval);
      this.websocket.onclose = () => { /*重连*/
        setTimeout(() => {
          if (this.websocket !== null) {
            console.log("重连websocket");
            this.connect();
          }
        },this.reconnectInterval);
      };
    },handleReceivedData(data) { /*消息处理*/
      console.log("----------");
      console.log(data);
      if (data && data.type !== "register") {
        if ("length" in data) {
          console.log("length_1");
          for (let i = 0; i < data.length; i++) {
            let d = JSON.parse(data[i]["state"]);
            let index1 = this.tabData.findIndex((fruit) => { /*总列表状态改变*/
              return fruit['did'] === d["did"] && fruit['pid'] === d["pid"];
            });
            if (index1 !== -1) {
              this.tabData[index1]["fire"] = this.timestampToTime(d['fire']);
              this.tabData[index1]["times"] = this.timestampToTime(data[i]['time'] * 1000);
              const now = new Date();
              if (now.getTime() - data[i]['time'] * 1000 <= 5 * 60 * 1000) {
                this.tabData[index1]["statusId"] = 2;
                this.tabData[index1]["statusName"] = "在线";
              } else {
                this.tabData[index1]["statusId"] = 1;
                this.tabData[index1]["statusName"] = "离线";
              }
            }
          }
        } else {
          console.log("length_2");
          if (!("state" in data)) {
            return;
          }
          let d = JSON.parse(data["state"]);
          console.log(d);
          // if (this.li_ctl.length > 0 && "did" in this.li_ctl[0]) {
          //   for (let i = 0; i < this.li_ctl.length; i++) {
          //     if (this.li_ctl[i]["name"] in d && d["did"] === this.li_ctl[i]["did"]) {
          //       this.li_ctl[i].value = d[this.li_ctl[i]["name"]]
          //       console.log("up_ctl", this.li_ctl[i]["name"], d[this.li_ctl[i]["name"]])
          //     }
          //   }
          // }
          let index1 = this.tabData.findIndex((fruit) => { /*总列表状态改变*/
            return fruit['did'] === d["did"] && fruit['pid'] === d["pid"];
          });
          if (index1 !== -1) {
            this.tabData[index1]["fire"] = d["fire"];
            this.tabData[index1]["times"] = this.timestampToTime(data['time'] * 1000);
            const now = new Date();
            if (now.getTime() - data['time'] * 1000 <= 5 * 60 * 1000) {
              this.tabData[index1]["statusId"] = 2;
              this.tabData[index1]["statusName"] = "在线";
            } else {
              this.tabData[index1]["statusId"] = 1;
              this.tabData[index1]["statusName"] = "离线";
            }
          }
        }
      }
      // console.log(this.li_dev)
    }
  },
  mounted() { /*页面加载时调用*/
    this.getPidArg(this.pid);
    this.xhTime();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    // fil_li_floor() {
    //   return this.li_floor.filter(item => {
    //     return !(this.edi_build && item.value !== this.edi_build);
    //   });
    // },
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/
    clearInterval(this.timer_sjtime); /*清除定时器*/
    this.timer_sjtime = null;
    clearInterval(this.timer_socket); /*清除定时器*/
    this.timer_socket = null;
    if (this.websocket !== null) { /*关闭websocket*/
      console.log("关闭websocket");
      if (this.websocket.readyState === WebSocket.OPEN) {
        let heartbeatMsg1 = {
          "type":"unregister",
          "devices":[],
          "projectId":localStorage.getItem("projectId")
        };
        this.websocket.send(JSON.stringify(heartbeatMsg1));
      }
      this.websocket.close();
      this.websocket = null;
    }
  }
};
</script>

<style>
@import '../../assets/css/aTab.css';

#glDevSonLd {
  height: 100vh;
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.grid_box { /*表格式布局*/
  display: grid;
  margin-top: 20px;
  grid-template-columns: repeat(auto-fill, 160px);
  grid-auto-flow: row; /*改为先列后行 column*/
  column-gap: 10px; /*行列间距*/
  row-gap: 10px;
  /*grid-template-rows: repeat(auto-fill, 300px); !*设置高度限制*!*/
  /*justify-content: center; align-content: center; !*居中显示*!*/
}

.grid_item {
  border-radius: 1px 1px 1px 1px; /* 左上角、右上角、右下角、左下角 */
  background: linear-gradient(to bottom, #ffffff, #f2f2f2 50%, #d9d9d9 100%);
  box-shadow: 0 0 6px #1D66DD, 0 0 10px rgba(0, 0, 0, 0.1) inset;
}

.man_li {
}
</style>



// WEBPACK FOOTER //
// src/pages/gls/glDevSonAir.vue